<template>
  <div id="zhibotc">
    <!--直播间需要同意的协议-->
    <div class="tc" v-if="show_xy">
      <div class="xyshell whiteB centerImg overHidden">
        <img class="close-img absoluteItem" @click="close_tc" src="../../assets/zhibotc.png" />
        <h3>观看直播须知</h3>
        <div class="text">{{ xy_text }}</div>
        <div class="button commonBk" @click="confirm">确认</div>
      </div>
    </div>
  </div>
</template>










<script>
export default {
  name: "zhibotc",
  data() {
    return {
      show_xy: false,
      xy_text: ""
    };
  },
  methods: {
    /**关闭弹窗 */
    close_tc() {
      this.show_xy = false;
    },
    /**用户点击确认须知 */
    confirm() {
      //存入cookie 30天
      this.$cookie.setC("zhiboxuzhi", "1", 30);
      this.show_xy = false;
    },
    /**检测是否需要给用户弹窗 */
    check_cookie() {
      if (this.$cookie.getC("zhiboxuzhi") !== "1") {
        this.get_config();
      }
    },
    /**链接config接口查看弹窗内容 */
    get_config() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("config", "app"), data, res => {
        if (res.data.data.result.list.first_msg_status === "1") {
          _this.xy_text = res.data.data.result.list.first_msg;
          _this.show_xy = true;
        }
      });
    }
  },
  mounted: function() {
    /**检测是否需要给用户弹窗 */
    this.check_cookie();
  },
  watch: {}
};
</script>











<style scoped lang="scss">
/*同意协议*/
.xyshell {
  width: 80%;
  padding: 1.875rem 1.25rem 1rem 1.25rem;
  border-radius: 0.5rem;
  font-size: 14px;
  transform-origin: left top;
  animation: adAnimation 0.3s forwards;
  -webkit-animation: adAnimation 0.3s forwards;

  .close-img {
    width: 1.375rem;
    height: 1.375rem;
    right: 0.5rem;
    top: 0.5rem;
  }

  h3 {
    text-align: center;
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 0.55rem;
  }

  .text {
    position: relative;
    text-align: justify;
    height: 14.875rem;
    overflow-y: scroll;
  }

  .button {
    text-align: center;
    padding: 0.625rem 0;
    font-size: 15px;
    color: white;
    margin-top: 0.5rem;
    border-radius: 1.875rem;
  }
}
</style>
